import { motion } from "framer-motion";
import { HeartHandshake, ArrowUpRight, Check } from "lucide-react";
import { EASE } from "../SectionHead";
import { railTrack, railItem, SwipeHint } from "../Rail";

const Tier = ({ t, i, fallback }) => {
  const href = t.url || fallback;
  const perks = (t.perks || "").split("\n").map((p) => p.trim()).filter(Boolean);
  return (
    <motion.div className={railItem} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.7, delay: i * 0.08, ease: EASE }}>
      <article data-testid={`patreon-tier-${t.id}`} className={`relative h-full clip-corner p-px ${t.highlight ? "bg-[#F5A524]" : "bg-[#F5A524]/25"}`}>
        <div className="h-full clip-corner bg-[#12131A] p-6 flex flex-col">
          {t.highlight && <span className="self-start mb-4 bg-[#F5A524] text-black font-mono text-[10px] font-bold tracking-[0.25em] px-2 py-1">FAN FAVOURITE</span>}
          <p className="font-mono text-[11px] tracking-[0.3em] text-[#F5A524]">TIER {String(i + 1).padStart(2, "0")}</p>
          <h4 className="mt-2 font-display font-black uppercase text-3xl leading-none">{t.name || "Supporter"}</h4>
          {t.price && <p data-testid={`patreon-tier-price-${t.id}`} className="mt-3 font-display font-black text-4xl text-[#F5A524]">{t.price}</p>}
          <ul className="mt-5 space-y-2 flex-1">
            {perks.map((p) => <li key={p} className="flex gap-2 text-sm text-zinc-300"><Check size={15} className="shrink-0 mt-0.5 text-[#F5A524]" />{p}</li>)}
          </ul>
          {href ? (
            <a href={href} target="_blank" rel="noreferrer" data-testid={`patreon-tier-join-${t.id}`}
              className={`mt-6 flex items-center justify-center gap-2 clip-tab py-3 font-mono text-xs font-bold tracking-[0.25em] transition-colors ${t.highlight ? "bg-[#F5A524] text-black hover:bg-white" : "border border-[#F5A524]/50 text-[#F5A524] hover:bg-[#F5A524] hover:text-black"}`}>
              JOIN <ArrowUpRight size={14} />
            </a>
          ) : <span className="mt-6 py-3 text-center font-mono text-[11px] tracking-[0.25em] text-zinc-400 border border-white/10">OPENING SOON</span>}
        </div>
      </article>
    </motion.div>
  );
};

export const PatreonBlock = ({ site }) => {
  const tiers = site.patreon_tiers ?? [];
  return (
    <div data-testid="patreon-block" className="grid lg:grid-cols-12 gap-8 lg:gap-10">
      <div className="lg:col-span-4">
        <p className="flex items-center gap-2 font-mono text-xs tracking-[0.3em] text-[#F5A524]"><HeartHandshake size={16} /> // PATREON</p>
        <h3 className="mt-3 font-display font-black uppercase text-4xl sm:text-5xl leading-[0.9]">Join the<br />inner circle</h3>
        <p className="mt-4 text-base text-zinc-300 leading-relaxed max-w-md">{site.patreon_blurb || "Early pages, process breakdowns and behind-the-scenes sketches — straight from the desk."}</p>
        {site.patreon_url && (
          <a href={site.patreon_url} target="_blank" rel="noreferrer" data-testid="patreon-main-link"
            className="mt-6 inline-flex items-center gap-3 clip-tab bg-[#F5A524] text-black px-6 py-3.5 font-mono text-xs font-bold tracking-[0.25em] hover:bg-white transition-colors">
            BECOME A PATRON <ArrowUpRight size={15} />
          </a>
        )}
      </div>
      {tiers.length > 0 && (
        <div className="lg:col-span-8">
          <SwipeHint count={tiers.length} testid="patreon-swipe-hint" />
          <div className={`${railTrack} md:grid md:grid-cols-2 xl:grid-cols-3 md:gap-5 items-stretch`}>
            {tiers.map((t, i) => <Tier key={t.id} t={t} i={i} fallback={site.patreon_url} />)}
          </div>
        </div>
      )}
    </div>
  );
};
